import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-10',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-10.component.html',
  styleUrls: []
})
export class Article10Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Dá para financiar imóvel de leilão? | Casato Brasil',
    description: 'Entenda quando imóveis de leilão aceitam financiamento, uso de FGTS e quais cuidados analisar antes de participar.'
  };
}
